module.exports = __webpack_public_path__ + "img/loadcurve.74f0d507.png";